import { render, staticRenderFns } from "./registerUniform.vue?vue&type=template&id=0cf9d02a&"
import script from "./registerUniform.vue?vue&type=script&lang=js&"
export * from "./registerUniform.vue?vue&type=script&lang=js&"
import style0 from "./registerUniform.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports